import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Hook data-id="element-3" />
        <Problem data-id="element-4" />
        <Mechanism data-id="element-5" />
        <Deliverables data-id="element-6" />
        <Audience data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <FAQ data-id="element-10" />
        <Offer data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}